module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAiUlEQVQ4jcXUyw2AIBBF0YsVWIoFsLEhYwdagrEhNhZgKXagISFxgR9mMtG3JOQA4QGfZe/8uHe+lq5XZSMJAwYgSNFLEJiAFWikqMtGzl1GJCQ04q2bly2bWApq0UdQg76CUrQIlKDFYCl6Vxt1/jmy6aWY1sa02KZPT4vF3NWm12CP0X6wtgEOTbdc+aSG3VIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@2x/ic_breadcrumbs_arrow@2x.png
// module id = 885
// module chunks = 0